import React, { useState } from 'react';
import { PUBLIC_CONTACT_EMAIL } from '../../constants/landingPublicContact';
import styles from './RefundPolicy.module.css';

interface RefundPolicyProps {
  className?: string;
}

const RefundPolicy: React.FC<RefundPolicyProps> = ({ 
  className = '' 
}) => {
  const [showModal, setShowModal] = useState(false);

  const handleLinkClick = (e: React.MouseEvent) => {
    e.preventDefault();
    setShowModal(true);
  };

  const closeModal = () => {
    setShowModal(false);
  };

  return (
    <>
      <div className={className}>
        <a 
          href="#"
          onClick={handleLinkClick}
          style={{ 
            color: '#fff', 
            textDecoration: 'none', 
            fontSize: '0.95rem',
            lineHeight: '1'
          }}
        >
          Refund and Cancellation Policy
        </a>
      </div>

      {showModal && (
        <div className={styles.modalOverlay} onClick={closeModal}>
          <div className={styles.modalContent} onClick={(e) => e.stopPropagation()}>
            <div className={styles.modalHeader}>
              <h2>Refund & Cancellation Policy – Tranzit.io</h2>
              <button 
                className={styles.closeButton}
                onClick={closeModal}
                aria-label="Close"
              >
                ×
              </button>
            </div>
            
            <div className={styles.modalBody}>
              <div className={styles.section}>
                <p><strong>Effective Date:</strong> April 2025</p>
                
                <p>
                  This Refund & Cancellation Policy governs all purchases and subscriptions made through Tranzit.io,
                  owned and operated by SMR Consulting LLC (DBA Tranzit.io), Houston, Texas.
                </p>

                <div className={styles.divider}>-----------------------------------------</div>

                <h3>1. REFUND POLICY</h3>

                <div className={styles.divider}>-----------------------------------------</div>

                <p>
                  All sales are final. Payments for subscriptions, usage-based AI fees, add-ons, onboarding services, and
                  renewals are non-refundable. Once processed, charges cannot be reversed.
                </p>

                <p>No refunds are issued for:</p>
                <ul>
                  <li>Partial use of the platform</li>
                  <li>Inactivity or non-use</li>
                  <li>Accidental renewals</li>
                  <li>Forgetting to cancel before renewal</li>
                  <li>Downtime, outages, or third-party disruptions</li>
                  <li>Changes in business needs</li>
                </ul>

                <p><strong>Billing Errors:</strong></p>
                <p>
                  Billing concerns must be reported within 5 business days. Valid errors may receive an account credit,
                  not a refund.
                </p>

                <p><strong>Chargebacks:</strong></p>
                <p>
                  Unauthorized chargeback attempts will result in immediate account suspension and possible
                  permanent removal.
                </p>

                <div className={styles.divider}>-----------------------------------------</div>

                <h3>2. CANCELLATION POLICY</h3>

                <div className={styles.divider}>-----------------------------------------</div>

                <p>
                  Users may cancel subscriptions at any time through their account settings. Cancellations take effect at
                  the end of the current billing cycle. No prorated refunds or partial credits will be issued.
                </p>

                <p>By canceling:</p>
                <ul>
                  <li>Your account remains active until the period ends</li>
                  <li>You retain access for the remainder of the paid term</li>
                  <li>Future billing stops upon cycle completion</li>
                </ul>

                <p>
                  Tranzit.io may terminate accounts for:
                </p>
                <ul>
                  <li>Non-payment</li>
                  <li>Fraudulent or abusive activity</li>
                  <li>Violations of Terms of Service</li>
                </ul>

                <p>
                  Terminated accounts are not eligible for refunds.
                </p>

                <div className={styles.divider}>-----------------------------------------</div>

                <h3>3. CONTACT INFORMATION</h3>

                <div className={styles.divider}>-----------------------------------------</div>

                <p>
                  SMR Consulting LLC (DBA Tranzit.io)<br />
                  Houston, Texas<br />
                  Email: {PUBLIC_CONTACT_EMAIL}
                </p>

                <div className={styles.divider}>-----------------------------------------</div>

                <p><strong>End of Policy</strong></p>
              </div>
            </div>
            
            <div className={styles.modalFooter}>
              <button 
                className={styles.closeButtonFooter}
                onClick={closeModal}
              >
                Close
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default RefundPolicy;






